// import Tablist from 'accedeweb-tablist';
import Overlay from '@accede-web/overlay';
import bind from '../helpers/bind';

// window.Overlay = Overlay;


function transitionEnd( e ){
  var el = e.target.closest( '[aria-hidden]' );

  if( e.propertyName === 'transform' ){
    el.removeEventListener( 'transitionend', transitionEnd );
    el.removeAttribute( 'style' );

    if(el.hasAttribute('data-reset')){
      el.layer.reset();
    }
  }
}


function handleEvent( e ){
  var btn = e.currentTarget,
      selector = btn.getAttribute( 'data-open' ),
      layer = document.querySelector( selector ),
      isWhole = btn.hasAttribute( 'data-dom' ),
      label = layer.getAttribute( 'data-label' ) || false;

  if( !btn.layer ){

    if( isWhole ){
      btn.layer = new Overlay( layer, {
        closeSelector: '.button-close',
        closeOnCancel: true,
        opener: btn
      } );
      console.log('whole');
    }
    else{
      btn.layer = new Overlay( {
        content: layer,
        className: 'overlay-wrapper closed',
        closeSelector: '.button-close',
        role: btn.getAttribute( 'data-role' ),
        label: label,
        opener: btn
      } );

      layer.removeAttribute( 'aria-hidden' );
    }

    btn.layer.addEventListener( 'close', () => {
      btn.layer.el.style.display = 'flex';
      btn.layer.el.addEventListener( 'transitionend', transitionEnd );
      btn.layer.el.classList.add( 'closed' );
    });
  }

  // window.requestAnimationFrame(() => {
    btn.layer.show();
    btn.layer.el.style.display = 'flex';

    window.requestAnimationFrame( () => {
      btn.layer.el.classList.remove( 'closed' );
    });
  // })
}
function init(){

  Array.prototype.forEach.call( document.querySelectorAll( '[data-open]' ), el => {
    bind( el, 'click', handleEvent );
  });
}

if( document.body.classList.contains( 'overlay' )  ){
  init();
}
